(() => {
  const styleId = 'k-usercentrics-font-size';

  const injectStyle = () => {
    const shadowRoot = document.querySelector('#usercentrics-root')?.shadowRoot;

    if (!shadowRoot) return false;
    if (shadowRoot.getElementById(styleId)) return true;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      #uc-center-container {
        font-size: 14px !important;
      }
    `;

    shadowRoot.appendChild(style);
    return true;
  };

  if (injectStyle()) return;

  const observer = new MutationObserver(() => {
    if (injectStyle()) observer.disconnect();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();